import React, { useState } from 'react';
const QuickAssessment = () => {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const questions = [{
    question: 'How long have you been experiencing knee pain?',
    options: ['Less than 3 months', '3-12 months', '1-3 years', 'More than 3 years']
  }, {
    question: 'How would you rate your pain level on most days?',
    options: ['Mild (1-3)', 'Moderate (4-6)', 'Severe (7-8)', 'Extreme (9-10)']
  }, {
    question: 'What activities have you given up due to knee pain?',
    options: ['Exercise/Sports', 'Walking/Hiking', 'Gardening/Housework', 'Social activities']
  }];
  const handleAnswer = answer => {
    setAnswers({
      ...answers,
      [step]: answer
    });
    if (step < questions.length - 1) {
      setStep(step + 1);
    } else {
      setShowResults(true);
    }
  };
  const resetQuiz = () => {
    setStep(0);
    setAnswers({});
    setShowResults(false);
  };
  if (showResults) {
    return <div className="bg-green-50 border-2 border-green-200 rounded-lg p-6 my-8 shadow-md" data-id="element-260">
        <h3 className="text-2xl font-bold text-green-800 mb-4" data-id="element-261">
          Your Personalized Assessment
        </h3>
        <div className="mb-4" data-id="element-262">
          <p className="text-lg mb-4" data-id="element-263">
            Based on your answers, you're an{' '}
            <span className="font-bold text-green-700" data-id="element-264">
              excellent candidate
            </span>{' '}
            for MyoQuell pain relief patches!
          </p>
          <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-265">
            <li className="text-gray-700" data-id="element-266">
              Your pain duration and intensity suggest you need a solution that
              works directly at the source
            </li>
            <li className="text-gray-700" data-id="element-267">
              You've been missing out on activities you love due to knee pain
            </li>
            <li className="text-gray-700" data-id="element-268">
              MyoQuell's targeted delivery system is specifically designed for
              your type of chronic knee pain
            </li>
          </ul>
          <p className="text-lg font-medium text-green-800 mb-6" data-id="element-269">
            You could experience significant relief within your first
            application!
          </p>
        </div>
        <div className="flex flex-col space-y-3" data-id="element-270">
          <a href="https://myoquell.com/products/escape-knee-pain-with-myoquell-herbal-patches" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg text-xl text-center transition-colors shadow-md animate-pulse" target="_blank" rel="noopener noreferrer" data-id="element-271">
            GET YOUR PERSONALIZED RELIEF NOW →
          </a>
          <button onClick={resetQuiz} className="text-green-700 hover:text-green-800 text-sm font-medium" data-id="element-272">
            Retake assessment
          </button>
        </div>
      </div>;
  }
  return <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-6 my-8 shadow-md" data-id="element-273">
      <h3 className="text-2xl font-bold text-blue-800 mb-2" data-id="element-274">
        Knee Pain Relief Assessment
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-275">
        Answer 3 quick questions to see if MyoQuell is right for you
      </p>
      <div className="mb-4" data-id="element-276">
        <div className="flex justify-between mb-1" data-id="element-277">
          <span className="text-sm font-medium text-blue-700" data-id="element-278">
            Question {step + 1} of {questions.length}
          </span>
          <span className="text-sm font-medium text-blue-700" data-id="element-279">
            {Math.round(step / questions.length * 100)}% Complete
          </span>
        </div>
        <div className="w-full bg-blue-200 rounded-full h-2" data-id="element-280">
          <div className="bg-blue-600 h-2 rounded-full transition-all duration-500" style={{
          width: `${step / questions.length * 100}%`
        }} data-id="element-281"></div>
        </div>
      </div>
      <h4 className="text-xl font-medium mb-4" data-id="element-282">{questions[step].question}</h4>
      <div className="space-y-3" data-id="element-283">
        {questions[step].options.map((option, index) => <button key={index} onClick={() => handleAnswer(option)} className="w-full text-left p-4 border-2 border-blue-200 rounded-lg hover:bg-blue-100 hover:border-blue-400 transition-colors" data-id="element-284">
            {option}
          </button>)}
      </div>
    </div>;
};
export default QuickAssessment;